import { Controller } from "@hotwired/stimulus"

// 메인 화면 공지의 "오늘 하루 닫기".
// PHP 는 notice_<GNO> 쿠키를 하루짜리로 심었다. 여기서는 서버에 보낼 필요가 없어
// localStorage 에 날짜를 적어 두고, 날짜가 바뀌면 다시 보이게 한다.
export default class extends Controller<HTMLElement> {
  static targets = ["item"]

  declare readonly itemTargets: HTMLElement[]

  connect(): void {
    const today = this.today()
    for (const item of this.itemTargets) {
      if (this.read(item.dataset.key) === today) item.hidden = true
    }
  }

  dismiss(event: Event): void {
    const item = (event.currentTarget as HTMLElement).closest<HTMLElement>("[data-notice-dismiss-target='item']")
    if (!item) return

    this.write(item.dataset.key, this.today())
    item.hidden = true
  }

  private today(): string {
    return new Date().toISOString().slice(0, 10)
  }

  private storageKey(key?: string): string {
    return `foodglory:${key ?? "notice"}`
  }

  // 시크릿 모드 등에서 localStorage 접근 자체가 예외를 던질 수 있다.
  private read(key?: string): string | null {
    try {
      return window.localStorage.getItem(this.storageKey(key))
    } catch {
      return null
    }
  }

  private write(key: string | undefined, value: string): void {
    try {
      window.localStorage.setItem(this.storageKey(key), value)
    } catch {
      /* 저장 못 해도 닫기 동작 자체는 유지한다 */
    }
  }
}
